// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftAttachmentStatus_decode($$enum) {
  if ($$enum === "Failed" || $$enum === "InProgress") {
    return $$enum;
  }
  
}

function localDraftAttachmentStatus_fromString(str) {
  return localDraftAttachmentStatus_decode(str);
}

function localDraftGeocodingStatus_decode($$enum) {
  if ($$enum === "ErrorDuplicateListing" || $$enum === "Error" || $$enum === "Valid" || $$enum === "Called" || $$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries") {
    return $$enum;
  }
  
}

function localDraftGeocodingStatus_fromString(str) {
  return localDraftGeocodingStatus_decode(str);
}

function localDraftSaveStatus_decode($$enum) {
  if ($$enum === "Saved" || $$enum === "SaveInProgress" || $$enum === "FirstSaveInProgress" || $$enum === "NotSaved" || $$enum === "SaveFailed") {
    return $$enum;
  }
  
}

function localDraftSaveStatus_fromString(str) {
  return localDraftSaveStatus_decode(str);
}

var Utils = {
  localDraftAttachmentStatus_decode: localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: localDraftAttachmentStatus_fromString,
  localDraftGeocodingStatus_decode: localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: localDraftGeocodingStatus_fromString,
  localDraftSaveStatus_decode: localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: localDraftSaveStatus_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayPreviewGlobalValidityIndicator_formState",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidators_formState"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filesStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imagesStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftSaveStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
